import React, { useState, useCallback } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { useApiMode } from '../context/ApiModeContext';
import './Settings.css';

// Demo credentials – in production these would come from your backend
const DEMO_CUSTOMER_TOKEN = 'AB12CD34EF';
const DEMO_SALT = 'xy98zw76vu';
const DEMO_SECRET_KEY = 'a1b2c3d4e5f6789012345678abcdef12';

function CopyButton({ value, label }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed', err);
    }
  }, [value]);

  return (
    <button
      type="button"
      className="settings-copy-btn"
      onClick={handleCopy}
      title={copied ? 'Copied!' : `Copy ${label}`}
      aria-label={`Copy ${label}`}
    >
      {copied ? (
        <span className="settings-copy-icon copied">✓</span>
      ) : (
        <span className="settings-copy-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
          </svg>
        </span>
      )}
    </button>
  );
}

function SecretField({ value, label, className = '' }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="settings-field-row">
      <input
        type={visible ? 'text' : 'password'}
        className={`settings-field-input ${className}`}
        value={value}
        readOnly
      />
      <button
        type="button"
        className="settings-icon-btn"
        onClick={() => setVisible((v) => !v)}
        title={visible ? 'Hide' : 'Show'}
        aria-label={visible ? 'Hide' : 'Show'}
      >
        <span className="settings-eye-icon" aria-hidden="true">
          {visible ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
              <line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          )}
        </span>
      </button>
      <CopyButton value={value} label={label} />
    </div>
  );
}

const Settings = () => {
  const { apiBaseUrl } = useApiMode();

  return (
    <DashboardLayout>
      <div className="settings-page">
        <div className="settings-card card">
          <h2 className="settings-title">API &amp; Credentials</h2>

          <div className="settings-section">
            <label className="settings-label">API Base URL</label>
            <div className="settings-field-row">
              <code className="settings-field-value">{apiBaseUrl}</code>
              <CopyButton value={apiBaseUrl} label="API Base URL" />
            </div>
          </div>

          <div className="settings-section">
            <label className="settings-label">Customer Token</label>
            <SecretField value={DEMO_CUSTOMER_TOKEN} label="Customer Token" className="settings-token-uppercase" />
          </div>

          <div className="settings-section">
            <label className="settings-label">Salt</label>
            <SecretField value={DEMO_SALT} label="Salt" className="settings-token-lowercase" />
          </div>

          <div className="settings-section">
            <label className="settings-label">Secret Key</label>
            <SecretField value={DEMO_SECRET_KEY} label="Secret Key" className="settings-secret-key" />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Settings;
